import { Box } from '@mui/material';
import { Control, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SearchFilters } from '../types/search.types';
import { DistanceSlider } from '@/shared/components/forms';

interface DistanceFilterProps {
  readonly control: Control<SearchFilters>;
  readonly watch: UseFormWatch<SearchFilters>;
}

export function DistanceFilter({ control }: Readonly<DistanceFilterProps>) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <DistanceSlider
        control={control}
        enabledFieldName="distanceEnabled"
        distanceFieldName="maxDistance"
        label={t('search.distance.label')}
      />
    </Box>
  );
}
